import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.storeScroll = this.storeScroll.bind(this)
    this.restoreScroll = this.restoreScroll.bind(this)
    document.addEventListener("turbo:before-stream-render", this.storeScroll)
    document.addEventListener("turbo:render", this.restoreScroll)
    this.storedScroll = null
    this.activeElement = null
    this.activeIdentifier = null
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.storeScroll)
    document.removeEventListener("turbo:render", this.restoreScroll)
  }

  storeScroll(event) {
    const turboStream = event.target
    const turboTarget = turboStream?.getAttribute?.("target")
    if (!this.shouldPreserve(turboTarget)) return
    this.storedScroll = window.scrollY
    const active = document.activeElement
    if (active && typeof active.blur === "function" && !active.hasAttribute("data-preserve-scroll-ignore")) {
      this.activeElement = active
      this.activeIdentifier = this.identifierFor(active)
    } else {
      this.activeElement = null
      this.activeIdentifier = null
    }
  }

  restoreScroll() {
    if (this.storedScroll === null) return
    const position = this.storedScroll
    this.storedScroll = null
    window.scrollTo({ top: position, behavior: "auto" })
    const element = this.elementToFocus()
    if (element && typeof element.focus === "function") {
      element.focus({ preventScroll: true })
    }
    this.activeElement = null
    this.activeIdentifier = null
  }

  shouldPreserve(target) {
    if (!target) return false
    const preservedTargets = [
      "tasting-session-scoreboard",
      "tasting-session-participants"
    ]
    return preservedTargets.includes(target)
  }

  elementToFocus() {
    if (this.activeElement && document.contains(this.activeElement)) {
      return this.activeElement
    }
    if (!this.activeIdentifier) return null
    return (
      document.querySelector(`[data-preserve-scroll-key="${this.activeIdentifier}"]`) ||
      document.getElementById(this.activeIdentifier)
    )
  }

  identifierFor(element) {
    if (!element) return null
    if (element.dataset?.preserveScrollKey) {
      return element.dataset.preserveScrollKey
    }
    return element.id || null
  }
}
